module.exports = "//d274d294w9cx2v.cloudfront.net/c8cff767c859ac3711f0d3ab9272703be8886eb0/images/payPalBadge.png";